/*
  Miamon — estado del header.
  Marca <html> con `mm-scrolled` en cuanto el usuario se despega del tope.
  El CSS se encarga del resto: en la home el header nace transparente encima
  del hero y al hacer scroll gana fondo, blur y borde.

  Va aparte del sticky de Dawn (desactivado en header-group.json) porque
  necesitamos dos estados con control fino, no ocultar/mostrar al scrollear.
*/
(function () {
  var root = document.documentElement;
  var THRESHOLD = 24;
  var ticking = false;

  function update() {
    ticking = false;
    var scrolled = (window.pageYOffset || root.scrollTop) > THRESHOLD;
    root.classList.toggle('mm-scrolled', scrolled);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Estado correcto si se recarga a media página o se llega por un ancla.
  update();
})();
